import { NativeSelect } from "lib/miolo";
import type { MenuProvided } from "react-instantsearch-core";
import { connectMenu } from "react-instantsearch-dom";

const RealEstateFundAudienceMenu = connectMenu<MenuProvided>(({ refine, currentRefinement }) => {
  return (
    <div className="space-y-4">
      <h3 className="font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500">Publico-alvo</h3>

      <NativeSelect value={currentRefinement || ""} onChange={(event) => refine(event.currentTarget.value || "")}>
        <option value="">Todos</option>
        <option value="Investidor Profissional">Investidor Profissional</option>
        <option value="Investidor Qualificado">Investidor Qualificado</option>
        <option value="Investidor Qualificado e Profissional">Investidor Qualificado e Profissional</option>
        <option value="Investidores em Geral">Investidores em Geral</option>
      </NativeSelect>
    </div>
  );
});

export default function RealEstateFundAudience() {
  return <RealEstateFundAudienceMenu attribute="audience" />;
}
